/*
 * Filename: base-class-store.ts
 * Description: this file act as a store to save data of user.
 */
import { BaseClassData } from "./models/base-classes.model";


/** 
 * @description App Store Creation
 */
export const BaseClassDataStore = BaseClassData.create({
    BaseClassObject:{}
});

export type IUserDetailsStore = typeof BaseClassData.Type;
